import { Box, IconButton, InputAdornment, SxProps, TextField } from "@mui/material"
import { useState } from "react";
import { MdCleaningServices } from "react-icons/md";

interface Props {
    id: string;
    input: string;
    variant?: 'outlined' | 'filled' | 'standard';
    customStyles?: SxProps;
    onChange?: (value: string) => void;
    placeholder?: string
}

export const BarraBusqueda: React.FC<Props> = ({ id, variant = 'outlined', customStyles, input, onChange, placeholder = 'Buscar...' }) => {
    const [inputValue, setInputValue] = useState<string>(input);
    const clearInput = () => {
        setInputValue("");
        if (onChange) {
            onChange(""); // Notifica al padre que se limpió el campo
        }
    };

    // const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     if (onChange) {
    //         onChange(event.target.value); // Llama a la función onChange pasada como prop
    //     }
    // };

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;
        setInputValue(newValue);
        if (onChange) {
          onChange(newValue);
        }
      };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center', // Alinea el texto
                ...customStyles,
            }}
        >
            <TextField
                id={id}
                variant={variant}
                size="small"
                sx={{ width: '100%' }}
                value={inputValue}
                onChange={handleInputChange}
                placeholder={placeholder}
                InputProps={{
                    endAdornment: inputValue && ( // Solo muestra el botón si hay texto
                        <InputAdornment position="end">
                            <IconButton onClick={clearInput} size="small">
                                <MdCleaningServices />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        </Box>
    )
}